import { useGetLatestApprovalQuery } from '../../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsRpc.hooks';
import { APP_GOVERNANCE_APPROVAL_ACTION, APP_GOVERNANCE_APPROVAL_TYPE } from '../constants';
//Retrieves latest approval request for a given objectId
export function useGetLatestProductApprovalRequest({
  approvableObjectId
}) {
  var _data$approval, _data$approval2;
  const {
    data,
    loading,
    error,
    refetch
  } = useGetLatestApprovalQuery({
    variables: {
      approvalType: APP_GOVERNANCE_APPROVAL_TYPE,
      approvalAction: APP_GOVERNANCE_APPROVAL_ACTION,
      approvableObjectId: approvableObjectId === undefined ? 0 : approvableObjectId
    },
    skip: approvableObjectId === undefined
  });
  const requestStatus = data === null || data === void 0 || (_data$approval = data.approval) === null || _data$approval === void 0 ? void 0 : _data$approval.approvalStatus;
  const requesterId = data === null || data === void 0 || (_data$approval2 = data.approval) === null || _data$approval2 === void 0 || (_data$approval2 = _data$approval2.requester) === null || _data$approval2 === void 0 ? void 0 : _data$approval2.id;
  const hasLatestRequestData = (data === null || data === void 0 ? void 0 : data.approval) !== undefined;
  return {
    data,
    requestStatus,
    requesterId,
    hasLatestRequestData,
    loading,
    error,
    refetch
  };
}